import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import Api from 'utils/api/Api';
import { useParams } from "react-router-dom";

export const SchoolRecommendLatest = ()=>{
    const { school } = useParams();

    const {data:recommendList, isLoading} = useQuery({
        queryKey:['/home/recommend/school'],
        queryFn:()=>Api.get('/api/recommend/school'),
        staleTime:24*60*60*1000,
        gcTime:24*60*60*1000
    });
    
    const list = useMemo(() => {
        if( isLoading )return null;
        if( recommendList.data?.length<=0 )return null;
        return recommendList.data?.map((recommend, key)=>{
            return (
                <div className="schoolItem" key={key}>
                    <div className="recommend activity" key={key}>
                        <Link to={`/${school}/recommend/school?id=${recommend.id}`}>
                            <img src={`${process.env.PUBLIC_URL}/static/images/recommend/schoolRecommend${key}.jpg`} alt="우리학교에서 추천해요" />
                            <div className="school">{recommend.title.replace('초등학교', '초')}</div>
                        </Link>
                    </div>
                </div>
            )
        });
    }, [recommendList, isLoading, school]);


    return (
        <div className="schoolRecommend" id="schoolRecommend">
            <div className="inner">
                <div className="subTitle">우리학교에서 추천해요</div>
                <div className="list">
                    {list}
                </div>
            </div>
        </div>
    )    

};